import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

export default function ComboBox(props) {

  function handleSelect(obj){
    props.handleSelect(obj);
  }

  return (
    <Autocomplete
      value={{ questionTypeName: props.defaultValue }} 
      isOptionEqualToValue={(option, value) => option.questionTypeName === value.questionTypeName}
      getOptionLabel={(option) => ((option && option.questionTypeName)?option.questionTypeName:'')} 
      options={props.options}
      sx={{ width: '100%' }}
      onChange={(event, myObj) => handleSelect(myObj)}
      renderInput={(params) => <TextField {...params} size='small' variant={props.variant?props.variant:'standard'} />}
    />
  );
}

// const top100Films = [
//     { title: 'The Shawshank Redemption', year: 1994 },
//     { title: 'The Godfather', year: 1972 },
//     { title: 'The Godfather: Part II', year: 1974 },
//     { title: 'The Dark Knight', year: 2008 },
//     { title: '12 Angry Men', year: 1957 }
// ]